import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchSelectArticleComponent } from '@domgen/dgx-fe-forms/select';
import { ArticleSearchFormFieldComponentService } from '../../services/article-search-form-field/article-search-form-field-component.service';
@Component({
  selector: 'article-search-form-field',
  templateUrl: './article-search-form-field.component.html',
  styleUrls: ['./article-search-form-field.component.scss'],
  providers: [ArticleSearchFormFieldComponentService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SearchSelectArticleComponent],
  standalone: true,
})
export class ArticleSearchFormFieldComponent {
  @Input() placeholder?: string;
  @Input() title?: string;

  constructor(readonly cs: ArticleSearchFormFieldComponentService) {}

  onSearchedTerm(formValue: string): void {
    this.cs.updateArticlesOptions(formValue);
  }
}
